import { PromoterTypes } from '@mm/state/model/PromoterModel';

const DATA_API_BLOCK = `
<script>
window.mmDataLayer = window.mmDataLayer || [];
function mmData(o) { mmDataLayer.push(o); }
</script>`;
type DefaultProps = {
  globalJavascriptBaseUrl: string;
  pageId: string;
  ref?: string;
  enableDataApi?: boolean;
};

type MainProps = {
  type: string;
  globalJavascriptBaseUrl: string;
  pageId: string;
  ref?: string;
  enableDataApi?: boolean;
};

const getMMGlobalJSCode = ({
  globalJavascriptBaseUrl,
  pageId,
  ref,
}: DefaultProps) =>
  `<script async="async" src="https://${globalJavascriptBaseUrl}/js/${pageId}.js"></script>`;

export const getShopifyJSCode = ({
  globalJavascriptBaseUrl,
  pageId,
}: DefaultProps) =>
  `window.xrayShopify = { analytics, browser, init };
var xray = document.createElement('script');
xray.src = 'https://${globalJavascriptBaseUrl}/js/${pageId}.js';
xray.type = 'text/javascript';
document.body.appendChild(xray);`;

const getCheckboxCode = ({
  globalJavascriptBaseUrl,
  pageId,
  ref,
}: DefaultProps) => `
${getMMGlobalJSCode({ globalJavascriptBaseUrl, pageId, ref })}
<div class="mobilemonkey-checkbox" ref="${ref}"></div>
`;

const getSendToMessengerPlugin = ({
  globalJavascriptBaseUrl,
  pageId,
  ref,
}: DefaultProps) => `
${getMMGlobalJSCode({ globalJavascriptBaseUrl, pageId, ref })}
<div class="mobilemonkey-send-to-messenger" ref="${ref}"></div>
`;

const getChatWidgetCode = ({
  globalJavascriptBaseUrl,
  pageId,
  ref,
  enableDataApi,
}: DefaultProps) =>
  getMMGlobalJSCode({ globalJavascriptBaseUrl, pageId, ref }) +
  (enableDataApi ? DATA_API_BLOCK : '');

const mapping = new Map([
  [PromoterTypes.CUSTOMER_CHAT, getChatWidgetCode],
  [PromoterTypes.CHECKBOX, getCheckboxCode],
  [PromoterTypes.MESSENGER, getSendToMessengerPlugin],
  [PromoterTypes.FB_COMMENT_GUARD, () => {}],
  [PromoterTypes.OPTIN, getMMGlobalJSCode],
  [PromoterTypes.INSTAGRAM_WELCOMER, () => {}],
  [PromoterTypes.GETEMAILS, getMMGlobalJSCode],
] as [string, any][]);

export default ({
  type,
  globalJavascriptBaseUrl,
  pageId,
  ref,
  enableDataApi,
}: MainProps) => {
  try {
    return mapping.get(type)({
      globalJavascriptBaseUrl,
      pageId,
      ref,
      enableDataApi,
    });
  } catch (err) {
    console.dir({ err, mapping, type });
  }
};
